import { Instagram, Music2, Globe, MessageSquare, Fuel, ShoppingBag, Crown, Mail, Calendar, Heart, Youtube, DollarSign } from "lucide-react";
import { Link } from "react-router-dom";

const BRAND_LOGO =
  "https://customer-assets.emergentagent.com/job_journey-hub-283/artifacts/6ld7fx8l_file_00000000ae8871f5b0415f16ffc8ce51~2.png";

// Each link: { label, sublabel, href, external, icon, accent }
const LINKS = [
  {
    label: "Instagram",
    sublabel: "@fuelmeh",
    href: "https://instagram.com/fuelmeh",
    icon: <Instagram />,
    accent: "#FF1493",
    external: true,
  },
  {
    label: "TikTok",
    sublabel: "@fmaa.fuelmeh",
    href: "https://tiktok.com/@fmaa.fuelmeh",
    icon: <Music2 />,
    accent: "#FF1E1E",
    external: true,
  },
  {
    label: "YouTube",
    sublabel: "@FMAA-FUELMEH",
    href: "https://www.youtube.com/@FMAA-FUELMEH",
    icon: <Youtube />,
    accent: "#FFC107",
    external: true,
  },
  {
    label: "Website",
    sublabel: "www.fuelmeh.com",
    href: "https://www.fuelmeh.com",
    icon: <Globe />,
    accent: "#FF1493",
    external: true,
  },
  // Live Map tile hidden pre-launch — restore when the road trip begins.
  // {
  //   label: "Live Map",
  //   sublabel: "Track me in real time",
  //   href: "/map",
  //   icon: <MapPin />,
  //   accent: "#FF1493",
  // },
  {
    label: "Shop the Drops",
    sublabel: "48-hour limited merch",
    href: "/shop",
    icon: <ShoppingBag />,
    accent: "#FF1E1E",
  },
  {
    label: "Tour Pass · $9",
    sublabel: "VIP early access + Founding Pin",
    href: "/tour-pass",
    icon: <Crown />,
    accent: "#FFC107",
  },
  {
    label: "RSVP — Tour List",
    sublabel: "Get pinged when I hit your city",
    href: "/rsvp",
    icon: <Calendar />,
    accent: "#FF1493",
  },
  {
    label: "Fuel the Journey",
    sublabel: "Drop $5 and become a mile",
    href: "/fuel",
    icon: <Fuel />,
    accent: "#FFC107",
  },
  {
    label: "Cash App",
    sublabel: "$FMAAFuelMeh",
    href: "https://cash.app/$FMAAFuelMeh",
    icon: <DollarSign />,
    accent: "#FFC107",
    external: true,
  },
  {
    label: "Brand Partnerships",
    sublabel: "Press kit · Sponsor deck · Rate card",
    href: "/press",
    icon: <Mail />,
    accent: "#FF1E1E",
  },
  {
    label: "Comment / Suggest",
    sublabel: "Tell us what you want to see",
    href: "/comment",
    icon: <MessageSquare />,
    accent: "#FF1493",
  },
];

export default function LinksPage() {
  return (
    <div className="min-h-[calc(100vh-64px)] py-12 px-5 grain" data-testid="links-page">
      <div className="max-w-md mx-auto">
        {/* Brand crest */}
        <div className="text-center">
          <img
            src={BRAND_LOGO}
            alt="FMAA"
            className="w-44 mx-auto border border-white/10"
            data-testid="links-brand-image"
          />
          <div className="font-display text-3xl tracking-[0.18em] uppercase mt-5">FMAA</div>
          <div className="overline mt-2">FuelMeh Across America</div>
          <p className="font-script text-2xl text-white/85 mt-3">
            Your favorite roadside distraction.
          </p>
          <p className="text-xs font-mono-tactical text-white/50 uppercase tracking-[0.25em] mt-3">
            50 States · No Repeats · All Vibes
          </p>
        </div>

        {/* Link buttons */}
        <div className="mt-10 space-y-3">
          {LINKS.map((link) => {
            const inner = (
              <>
                <span
                  className="w-10 h-10 flex items-center justify-center shrink-0"
                  style={{ background: link.accent, color: link.accent === "#FFC107" ? "#0A0A0A" : "#fff" }}
                >
                  {link.icon}
                </span>
                <span className="flex-1 min-w-0 text-left">
                  <span className="block font-display text-lg uppercase tracking-wider truncate">
                    {link.label}
                  </span>
                  <span className="block text-[11px] font-mono-tactical uppercase tracking-[0.2em] text-white/55 truncate">
                    {link.sublabel}
                  </span>
                </span>
              </>
            );

            const className =
              "w-full flex items-center gap-3 p-1 pr-4 bg-[#141414] border border-white/10 hover:border-[var(--rl-border-hot)] hover:-translate-y-0.5 transition-all duration-200";

            return link.external ? (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noreferrer"
                className={className}
                data-testid={`link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {inner}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.href}
                className={className}
                data-testid={`link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {inner}
              </Link>
            );
          })}
        </div>

        <div className="mt-10 flex items-center justify-center gap-2 text-white/60 text-sm">
          <Heart size={14} className="text-[#FF1493]" />
          <span>One creator. Fifty states. Always rolling.</span>
        </div>

        <div className="mt-3 text-center text-[10px] uppercase tracking-[0.3em] text-white/30 font-mono-tactical">
          © 2026 FMAA
        </div>
      </div>
    </div>
  );
}
